import { Layer as olLayer } from 'ol/layer'
import $ from 'jquery'

/**
 * @module
 * @api
 */

/**
 * Config class
 * @param {object} config
 * @constructor
 */
export default function Config(config) {
  $.extend(this, config || {})
}

/**
 * Update layer viewparams
 * @param {string} layerName
 * @param {object} params
 * @memberof! module:api/Config#
 * @api
 */
Config.prototype.updateParams = function(layerName, params) {
  var layer = this.getLayerByName(layerName)
  var source = layer.getSource()
  source.updateParams(params)

  // Update Olga layer configuration, issue #580
  const olgaLayerConfig = layer.get('olga_')
  if (olgaLayerConfig) {
    olgaLayerConfig.source.params = Object.assign(
      olgaLayerConfig.source.params,
      params
    )
    layer.set('olga_', olgaLayerConfig)
  }
}

/**
 * Get first layer with selected name
 * @param {string} layerName
 * @return {olLayer} Matching layer
 * @memberof! module:api/Config#
 * @api
 */
Config.prototype.getLayerByName = function(layerName) {
  var layers = this.map.getLayers().getArray()
  var foundLayers = layers.filter(function(layer) {
    return layer.get('name') === layerName
  })
  return foundLayers[0]
}
/**
 * Force a recalculation of the map viewport size to match #map div size.
 *
 * @param {void}
 * @return {Array.<Number>} Array of numbers, [width,height], representing the size of the map in the DOM as pixels
 *
 */
Config.prototype.updateMapSize = function() {
  this.map.updateSize()
  return this.map.getSize()
}
